import React from "react";
import { Grid, withStyles, Divider, Avatar, Checkbox } from "@material-ui/core";
import appConstants from "../../../../../../../appConstants";
import NoData from "./NoData";
import constants from "../constants";
import { formatDeliveryOrServiceWindow } from "../../../../utils/utils";
import { EmptyTimeFormat } from "../../../../../../common/utils/stringUtils";

const styles = (theme) => ({
  root: {
    paddingLeft: "0px",
    paddingTop: "8px",
    display: "flex",
    alignItems: "start",
    verticalAlign: "middle",
    height: "100%",
    color: theme.HeaderSelectedText,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  checked: {
    color: theme.HeaderSelectedText,
  },
  label: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.iconColor,
    lineHeight: "14px",
    fontWeight: 400,
    marginRight: "8px",
  },
  value: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.completeStopText,
    lineHeight: "14px",
    fontWeight: 600,
  },
  headerDivider: {
    backgroundColor: theme.gridIconBorderColor,
    opacity: 0.2,
    marginTop: 12,
  },
  stopName: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textAlign: "left",
    display: "flex",
    lineHeight: "16px",
    color: theme.HeaderSelectedText,
  },
  avatar: {
    color: theme.infoTextColor,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.infoTextColor}`,
    width: 25,
    height: 25,
    fontSize: theme.headerTextFontSize,
  },
  stopContainer: {
    marginTop: "16px",
  },
});

const ShipmentsList = (props) => {
  const { classes, data, onShipmentSelected } = props;

  if (data?.length === 0) {
    return <NoData label={constants.MESSAGES.NO_BILLS} />;
  }
  return data.map((bill, index) => {
    const { shipment, stop, isChecked } = bill;
    return (
      <Grid container spacing={8} className={`${classes.stopContainer} customScroll`}>
        <Grid item>
          <Checkbox
            key={shipment.proId}
            classes={{
              root: classes.root,
              checked: classes.checked,
            }}
            disableRipple
            color="primary"
            onChange={onShipmentSelected(shipment.shipmentId)}
            checked={isChecked}
          />
        </Grid>
        <Grid item>
          <Avatar className={classes.avatar}>{stop.stopType[0]}</Avatar>
        </Grid>
        <Grid item>
          <Grid item>
            <span className={classes.stopName}>{stop.name}</span>
          </Grid>
          <Grid item className={classes.label}>
            {stop.address}
          </Grid>
          {stop.stopType === appConstants.STOP_TYPE.Delivery && (
            <Grid item>
              <span className={classes.label}>Delivery Window:</span>
              <span className={classes.value}>
                {formatDeliveryOrServiceWindow(stop.deliveryWindow, EmptyTimeFormat)}
              </span>
            </Grid>
          )}
          <Grid item>
            <span className={classes.label}>Pro#</span>
            <span className={classes.value}>{shipment.proId || "__"}</span>
          </Grid>
        </Grid>
        {index < data.length - 1 && (
          <Grid item xs={12}>
            <Divider className={classes.headerDivider} light />
          </Grid>
        )}
      </Grid>
    );
  });
};

export default withStyles(styles)(ShipmentsList);
